/**
 * The one reader of `NEXT_PUBLIC_API_BASE_URL`: the BFF base URL every
 * browser BFF call, the OTLP exporters, the preconnect hint and the mock
 * handlers are built on. `bffBase.test.ts` fails if any other module reads it.
 *
 * `next.config.mjs` bakes it into every build (`lib/bffTestOrigin.mjs`): the
 * backend's `api-customer.…` origin, or the unresolvable test origin under the
 * test env. There is no fallback: a missing or malformed value throws at first
 * use, so a broken build fails loudly instead of sending calls somewhere else.
 *
 * Read per call, never cached at module load: the unit suite switches it
 * between cases.
 */
export function bffBaseUrl(): string {
  const base = process.env.NEXT_PUBLIC_API_BASE_URL;
  if (!base) {
    throw new Error(
      "NEXT_PUBLIC_API_BASE_URL is not set: next.config.mjs bakes it into every build"
    );
  }
  let parsed: URL;
  try {
    parsed = new URL(base);
  } catch (error) {
    throw new Error(
      `NEXT_PUBLIC_API_BASE_URL is not an absolute URL: ${JSON.stringify(base)}`,
      { cause: error }
    );
  }
  if (parsed.protocol !== "https:" && parsed.protocol !== "http:") {
    throw new Error(
      `NEXT_PUBLIC_API_BASE_URL must be an http(s) URL: ${JSON.stringify(base)}`
    );
  }
  return base;
}

/** The BFF origin (`https://api-customer.…`, no path). */
export function bffOrigin(): string {
  return new URL(bffBaseUrl()).origin;
}
